<template>
  <div class="prop-container">
    <div class="d-flex justify-space-between align-center pb-3">
      <span>{{ $t('vuetifyWidgets.dr-snippet-editor.additionalProperties') }}</span>
      <v-btn icon color="primary" @click="addParam">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <div>
      <v-card outlined height="150px" style="overflow-y: auto">
        <v-list dense>
          <v-list-item
            v-for="(item, index) in paramsList"
            :key="index"
            class="py-1 objects-params-item"
            v-bind:class="{ 'v-list-item--active': activeIndex == index }"
            @click="selectItem(item.name, index)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle v-if="item.value.name" v-text="item.value.name"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action @click="deleteParam(item.name)">
              <v-btn icon>
                <v-icon color="grey lighten-1">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <div v-if="currentKey" class="py-3">
      <!-- Ключ свойства -->
      <v-text-field
        :label="$t('vuetifyWidgets.dr-snippet-editor.key')"
        v-model="propKey"
        clearable
        @change="changeKey"
      ></v-text-field>

      <!-- Тип свойства -->
      <v-select
        v-if="currentKey"
        :label="$t('vuetifyWidgets.dr-snippet-editor.type')"
        v-model="propType"
        :items="types"
        @input="changeItem"
      ></v-select>

      <!-- Название свойства которое будет отображатся -->
      <v-text-field
        :label="$t('vuetifyWidgets.dr-snippet-editor.name')"
        v-model="propVisibleName"
        clearable
        @change="changeItem"
      ></v-text-field>

      <!-- Базовое значение свойства -->
      <v-text-field
        v-if="propType"
        :label="$t('vuetifyWidgets.dr-snippet-editor.defaultValue')"
        v-model="propDefValue"
        clearable
        @change="changeItem"
      ></v-text-field>

      <!-- TODO: Доработать enum -->
      <!--<v-checkbox
        v-if="propType == 'string' || propType == 'boolean'"
        label="Использовать enum"
        color="success"
        v-model="propIsEnum"
        @change="changeItem"
        persistent-hint
        dense
      ></v-checkbox>

      <v-text-field
        v-if="propIsEnum"
        label="Значения enum"
        v-model="propEnumItems"
        clearable
        @change="changeItem"
      ></v-text-field>-->
    </div>
  </div>
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import propertyPanelMixin from '../../mixins/propertyPanel-mixin'

export default {
  mixins: [baseMixin, propertyPanelMixin],
  props: ['schema', 'propName', 'value', 'readonly'],
  data() {
    return {
      propKey: '',
      propType: 'string',
      propVisibleName: '',
      propDefValue: '',
      // TODO: Доработать enum
      //propIsEnum: false,
      //propEnumItems: '',
      currentKey: '',
      editableItemIndex: 0,
      activeIndex: 0,
      randomStringLength: 4,
      types: ['string', 'number', 'boolean'],
      paramsList: []
    }
  },
  created() {
    // Обновляем и задаём первое свойство
    this.refreshParamsList()
    if (Object.keys(this.objectParamsComputed).length) {
      this.selectItem(`${Object.keys(this.objectParamsComputed)[0]}`, 0)
    }
  },
  methods: {
    // Добавление нового свойства
    addParam() {
      const key = this.createRandomString(this.randomStringLength)
      this.currentKey = key
      const keyLength = Object.keys(this.objectParamsComputed).length
      let object = { ...this.objectParamsComputed }
      object[key] = {}
      this.objectParams = object
      this.editableItemIndex = keyLength
      this.activeIndex = keyLength
      this.propKey = key
      this.clearProps()
    },
    createRandomString(countSymbols) {
      let randomString = ''
      const possibleVal = 'abcdefghijklmnopqrstuvwxyz0123456789'
      for (var i = 0; i < countSymbols; i++) {
        randomString += possibleVal.charAt(Math.floor(Math.random() * possibleVal.length))
      }
      for (const prop in this.objectParamsComputed) {
        if (prop == `newParam_${randomString}`) {
          randomString += possibleVal.charAt(Math.floor(Math.random() * possibleVal.length))
        }        
      }
      
      return randomString
    },
    clearProps() {
      this.propType = 'string'
      this.propVisibleName = ''
      this.propDefValue = ''
      // TODO: Доработать enum
      //this.propIsEnum = false
      //this.propEnumItems = ''
    },
    deleteParam(key) {
      delete this.objectParamsComputed[key]
      this.objectParams = this.objectParamsComputed
      if (key == this.currentKey) {
        this.propKey = ''
        this.currentKey = ''
        this.clearProps()
      }
    },
    selectItem(item, index) {
      // если параметров нету, задаём первое свойство
      if (!item && !index && Object.keys(this.objectParams).length > 0) {
        item = Object.keys(this.objectParams)[0]
        index = 0
      }
      if (this.objectParams[item]) {
        this.editableItemIndex = index
        this.activeIndex = index
        this.currentKey = item
        this.propKey = item
        this.propType = this.objectParams[item].type ?? ''
        this.propVisibleName = this.objectParams[item].name ?? ''
        this.propDefValue = this.objectParams[item].default ?? ''
        // TODO: Доработать заполнение enum
        // if (this.objectParams[item].enum) {
        //   this.propIsEnum = true
        //   this.propEnumItems = this.objectParams[item].enum ? JSON.stringify(this.objectParams[item].enum) : ''
        // } else {
        //   this.propIsEnum = false
        // }
      }
    },
    changeItem() {
      this.objectParams[this.propKey].type = this.propType
      this.objectParams[this.propKey].name = this.propVisibleName
      this.objectParams[this.propKey].default = this.propDefValue
      if (!this.objectParams[this.propKey].default) {
        delete this.objectParams[this.propKey].default
      }
      if (!this.objectParams[this.propKey].name) {
        delete this.objectParams[this.propKey].name
      }
      // TODO: Доработать enum
      // if (this.propIsEnum && this.propEnumItems) {
      //   this.objectParams[this.propKey].enum = JSON.parse(this.propEnumItems)
      // }
      this.objectParams = this.objectParamsComputed
    },
    changeKey(val) {
      var param = {...this.objectParams[this.currentKey]}
      delete this.objectParams[this.currentKey]
      this.objectParams[val] = param
      this.objectParams = this.objectParamsComputed
    },
    // Приобразование объекта в массив для отрисовки
    refreshParamsList(objects) {
      if (objects && Object.keys(objects).length) {
        this.paramsList = Object.keys(objects).map(x => {
          return { name: x, value: objects[x]}
        })
      } else if (this.objectParams && Object.keys(this.objectParams).length) {
        this.paramsList = Object.keys(this.objectParams).map(x => {
          return { name: x, value: this.objectParams[x]}
        })
      } else {
        this.paramsList = []
      }
    }
  },
  watch: {
    objectParams(val) {
      this.refreshParamsList()
      if (!val) {
        this.propKey = ''
        this.currentKey = ''
        this.clearProps()
      } else {
        this.selectItem()
      }
    }
  },
  computed: {
    objectParams: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.refreshParamsList(val)
      }
    },
    objectParamsComputed() {
      if (!this.objectParams || Object.keys(this.objectParams).length === 0) {
        return {}
      }
      return this.objectParams
    }
  }
}
</script>

<style>
.prop-container {
  width: 100%;
}
</style>
